import { Admin, AppBar, Layout, Resource } from "react-admin";
import {
  ListCategories,
  CreateCategory,
  EditCategory,
} from "../Resources/Categories";
import {
  CreateJobOffer,
  EditJobOffer,
  ListJobOffers,
  ViewJobOffer,
} from "../Resources/JobOffers";
import { ListUsers, ViewUser, EditUser, CreateAdmin } from "../Resources/Users";
import { CreateStatus, EditStatus, ListStatuses } from "../Resources/Statuses";
import { EditPost, ListPosts, CreatePost } from "../Resources/Posts";
import {
  ListJobApplications,
  ViewJobApplication,
} from "../Resources/JobApplications";

import { dataProvider } from "../../dataProvider";
import authProvider from "../customAuthProvider";
import LoginPage from "../Login/Login";

import UserIcon from "@mui/icons-material/People";
import CategoryIcon from "@mui/icons-material/Category";
import WorkIcon from "@mui/icons-material/Work";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import FlagIcon from "@mui/icons-material/Flag";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import FactCheckIcon from "@mui/icons-material/FactCheck";

import {
  EditInterview,
  ListInterviews,
  ViewInterview,
} from "../Resources/Interviews";

import React from "react";
import { API_URL, APP_VERSION } from "../../constants";
import { LayoutProps } from "react-admin";

// Custom AppBar component to display API version on hover
const CustomAppBar = () => {
  const [apiVersion, setApiVersion] = React.useState<string | null>(null);

  React.useEffect(() => {
    fetch(API_URL + "/version")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch API version");
        }
        return res.text();
      })
      .then((version) => setApiVersion(version))
      .catch(() => {
        setApiVersion("Unknown");
      });
  }, []);

  return (
    <AppBar>
      <div
        style={{
          flexGrow: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <span
          title={`App Version: ${APP_VERSION} \n API Version: ${apiVersion || "Loading..."}`}
          style={{
            cursor: "pointer",
          }}
        >
          Info
        </span>
      </div>
    </AppBar>
  );
};

// Custom Layout component for v5
const CustomLayout = (props: LayoutProps) => {
  return <Layout {...props} appBar={CustomAppBar} />;
};

const AdminComponent = () => (
  <Admin
    dataProvider={dataProvider}
    authProvider={authProvider}
    layout={CustomLayout}
    loginPage={LoginPage}
    darkTheme={null}
    defaultTheme="light"
  >
    <Resource
      name="categories"
      list={ListCategories}
      icon={CategoryIcon}
      create={CreateCategory}
      edit={EditCategory}
      options={{ label: "Categoría de llamados" }}
    />
    <Resource
      name="job-offers"
      list={ListJobOffers}
      edit={EditJobOffer}
      create={CreateJobOffer}
      show={ViewJobOffer}
      icon={WorkIcon}
      options={{ label: "Llamados" }}
    />
    <Resource
      name="users"
      list={ListUsers}
      icon={UserIcon}
      show={ViewUser}
      edit={EditUser}
      create={CreateAdmin}
      options={{ label: "Usuarios" }}
    />
    <Resource
      name="statuses"
      list={ListStatuses}
      icon={FlagIcon}
      create={CreateStatus}
      edit={EditStatus}
      options={{ label: "Estados" }}
    />

    <Resource
      name="posts"
      list={ListPosts}
      icon={NewspaperIcon}
      edit={EditPost}
      create={CreatePost}
      options={{ label: "Publicaciones" }}
    />

    {/*
      <Resource
        name="skills"
        icon={SchoolIcon}
        options={{ label: "Habilidades" }}
        list={ListSkills}
        create={CreateSkill}
        edit={EditSkill}
      />
    */}

    <Resource
      name="job-applications"
      icon={HowToVoteIcon}
      options={{ label: "Postulaciones" }}
      list={ListJobApplications}
      show={ViewJobApplication}
    />

    <Resource
      name="interviews"
      icon={FactCheckIcon}
      options={{ label: "Entrevistas" }}
      list={ListInterviews}
      show={ViewInterview}
      edit={EditInterview}
    />
  </Admin>
);

export default AdminComponent;
